import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneProduct } from 'slice/productSlice'; 
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import { updateProduct } from 'slice/productSlice';

const UpdateProduct = () => {
    const { id } = useParams(); 
    const dispatch = useDispatch();
    const nevigate = useNavigate();
    const { loading, data } = useSelector((state) => state.product);
    const [formData, setFormData] = useState({
        productkey: '',
        name: '',
        sprice: '',
        unit: '',
        offer: '',
        quantity: '',
        plan_duration: '',
        long_description: '',
        images: []
    });
    const [imageFiles, setImageFiles] = useState([]);

    const formatImages = (images) => {
        if (!images) return [];
        if (Array.isArray(images)) {
            return images.filter((item) => typeof item === 'string' && item.trim() !== '');
        }
        if (typeof images === 'string') {
            const trimmed = images.trim();
            if (!trimmed) return [];
            try {
                const parsed = JSON.parse(trimmed);
                if (Array.isArray(parsed)) {
                    return parsed.filter((item) => typeof item === 'string' && item.trim() !== '');
                }
            } catch (error) {
                if (trimmed.includes(',')) {
                    return trimmed.split(',').map((item) => item.trim()).filter(Boolean);
                }
                return [trimmed];
            }
            return [trimmed];
        }
        return [];
    };

    useEffect(() => {
        dispatch(getOneProduct(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (Object.keys(data).length > 0) {
            setFormData({
                productkey: data.productkey || '',
                name: data.name || '',
                sprice: data.sprice || '',
                unit: data.unit || '',
                offer: data.offer || '',
                quantity: data.quantity || '',
                plan_duration: data.plan_duration || '',
                long_description: data.long_description || '',
                images: formatImages(data.images).length ? formatImages(data.images) : formatImages(data.image)
            });
            setImageFiles([]);
        }
    }, [data]);

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;

        if (type === 'file' && name === 'images') {
            setImageFiles(Array.from(files || []));
            return;
        }

        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('productkey', formData.productkey);
            formDataToSend.append('name', formData.name);
            formDataToSend.append('sprice', formData.sprice);
            formDataToSend.append('unit', formData.unit);
            formDataToSend.append('offer', formData.offer);
            formDataToSend.append('quantity', formData.quantity);
            formDataToSend.append('plan_duration', formData.plan_duration);
            formDataToSend.append('long_description', formData.long_description);
            imageFiles.forEach((file) => formDataToSend.append('images', file));

            dispatch(updateProduct({id: id, data: formDataToSend}))
            toast('Product updated successfully!');
            nevigate('/products')
        } catch (error) {
            console.error('There was a problem updating the product:', error.message);
        }
    };


    return (
        <>
        
        <div className='container-fluid px-lg-5'>
        <div className='mainheadig'>
                <h4 className='text-white font-weight-bold '> Update Product</h4>
            </div>
                <form onSubmit={handleSubmit}>
                <div className='row p-3'>
                    <div className='col-sm-4 mt-2'>
                        <label htmlFor='productKey'>Product Key</label>
                        <input type='text' id='productKey' name='productkey' value={formData.productkey} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-4 mt-2'>
                        <label htmlFor='productName'>Product Name</label>
                        <input type='text' id='productName' name='name' value={formData.name} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-4 mt-2'>
                        <label htmlFor='productName'>Product Price</label>
                        <input type='text' id='productName' name='sprice' value={formData.sprice} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-4 mt-2'>
                        <label htmlFor='productName'>Product Size</label>
                        <input type='text' id='productName' name='unit' value={formData.unit} className='form-control' onChange={handleChange}  />
                    </div>
                    <div className='col-sm-6 mt-2'>
                        <label htmlFor='productName'>Offer</label>
                        <input type='text' id='productName' name='offer' value={formData.offer} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-6 mt-2'>
                        <label htmlFor='productName'>Quantity</label>
                        <input type='text' id='productName' name='quantity' value={formData.quantity} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-6 mt-2'>
                        <label htmlFor='planDuration'>Plan Duration</label>
                        <input type='text' id='planDuration' name='plan_duration' value={formData.plan_duration} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-12 mt-2'>
                        <label htmlFor='productName'>Description</label>
                        <textarea rows={5} name='long_description' value={formData.long_description} className='form-control' onChange={handleChange}></textarea>
                    </div>
                    <div className='col-sm-4 mt-2'>
                        <input type='file' name='images' id='images' multiple onChange={handleChange}/>
                    </div>
                    <div className='col-sm-8 mt-2'>
                        {formData.images?.map((img, index) => (
                            <img key={index} src={`${process.env.REACT_APP_BACKEND}uploads/${img}`} className='img-fluid mr-2' alt='' width={90}/>
                        ))}
                        {imageFiles?.map((file, index) => (
                            <img key={index} src={URL.createObjectURL(file)} className='img-fluid mr-2' alt='' width={90}/>
                        ))}
                        </div>
                </div>
                <div className='my-3 text-right'>
                    <button className='btn addbtn' disabled={loading}>Update Product</button>
                </div>
                </form>
            </div>
            
        </>
    )
}

export default UpdateProduct
